import { a as appGlobalScript } from './ionic-global-08f4fb8a.js';
var globalScripts = appGlobalScript;
export { globalScripts as g };
